module.exports = __webpack_public_path__ + "img/bg_question_des_1.24cf6cbe.jpg";